import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconComponent } from '../../atoms/fa-icon/fa-icon.component';
import { OrbitRippleDirective } from '../../../directives/ripple.directive';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'orbit-button',
  standalone: true,
  imports: [CommonModule, FaIconComponent, OrbitRippleDirective],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  label = input<string>();
  ariaLabel = input<string>();
  inputId = input<string | null>();
  icon = input<IconProp>();
  styleClass = input<string>();
  testId = input<string>();
  loading = input<boolean, unknown>(false, { transform: booleanAttribute });
  disabled = input<boolean, unknown>(false, { transform: booleanAttribute });
  rounded = input<boolean, unknown>(false, { transform: booleanAttribute });
  outlined = input<boolean, unknown>(false, { transform: booleanAttribute });
  flat = input<boolean, unknown>(false, { transform: booleanAttribute });
  boldLabel = input<boolean, unknown>(false, { transform: booleanAttribute });
  size = input<'extra-small' | 'small' | 'default' | 'slim' | 'large'>('small');
  type = input<string>('button');
  severity = input<'primary' | 'secondary' | 'danger' | 'warning' | 'info' | 'success' | null>(
    'primary'
  );
  buttonClick = output<MouseEvent>();
  readonly spinnerIcon = faSpinnerThird;

  get buttonClass() {
    const styleClass = this.styleClass();
    const size = this.size();
    const label = this.label();

    return {
      'or-button-icon-only': this.icon() && !label,
      'or-button-text': label,
      'or-button-outlined': this.outlined(),
      'or-button-disabled': this.disabled(),
      'or-button-rounded': this.rounded(),
      'or-button-flat': this.flat(),
      'or-button-bold-label': this.boldLabel(),
      'or-button-xs': size === 'extra-small',
      'or-button-sm': size === 'small',
      'or-button-default': size === 'default',
      'or-button-sl': size === 'slim',
      'or-button-lg': size === 'large',
      [`or-button-${this.severity()}`]: true,
      [`${styleClass}`]: styleClass,
    };
  }

  handleClick(event: MouseEvent) {
    this.buttonClick.emit(event);
  }
}
